module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_9-45de36e8d0b0c32c2e607d6de4136f85.jpeg";